<template>
    <div class="loader-pdf-to-brief">
        <div class="loader-pdf-to-brief__content">
            <AiSpinner class="joy-mb-5" />
            <div class="loader-pdf-to-brief__text ai-color-gradient">
                <Transition>
                    <p v-if="displaySentence1">{{ $t('search.advanced.home-v2.loader.sentence.1') }}</p>
                </Transition>
                <Transition>
                    <p v-if="displaySentence2">{{ $t('search.advanced.home-v2.loader.sentence.2') }}</p>
                </Transition>
                <Transition>
                    <p v-if="displaySentence3">{{ $t('search.advanced.home-v2.loader.sentence.3') }}</p>
                </Transition>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
    import {onMounted, ref} from '#imports';
    import AiSpinner from '~/features/advanced-search/AiSpinner.vue';
    import {useAdvancedSearchTracker} from '~/features/advanced-search/tracking/tracker';

    const {trackFunnelStepViewed} = useAdvancedSearchTracker();

    const displaySentence1 = ref(false);
    const displaySentence2 = ref(false);
    const displaySentence3 = ref(false);

    onMounted(() => {
        trackFunnelStepViewed();

        setTimeout(() => {
            displaySentence1.value = true;
        }, 800);
        setTimeout(() => {
            displaySentence2.value = true;
        }, 1900);
        setTimeout(() => {
            displaySentence3.value = true;
        }, 3000);
    });
</script>

<style scoped lang="scss">
    .v-enter-active,
    .v-leave-active {
        transition:
            opacity 300ms ease-out,
            height 300ms ease-out,
            margin 300ms ease-out;
        opacity: 1;
        height: 20px;
        margin-bottom: var(--joy-core-spacing-7);
    }

    .v-enter-from,
    .v-leave-to {
        opacity: 0;
        height: 0;
    }

    .loader-pdf-to-brief {
        display: flex;
        height: 100%;

        &__content {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin: auto auto 50vh;

            p {
                margin-bottom: var(--joy-core-spacing-7);

                &:last-child {
                    font-size: var(--joy-font-size-primary-400);
                    font-weight: var(--joy-font-weight-bold);
                    color: var(--joy-color-primary-50);
                }
            }
        }

        &__text {
            text-align: center;
        }
    }
</style>
